<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600px">
    <template v-slot:title>Add Adjustment</template>
    <v-row>
      <v-col>
        <v-text-field
          label="Amount"
          v-model.number="amount"
          :outlined="outlinedInputs"
      /></v-col>
      <v-col>
        <taxes-list-select
          @onSelectTaxType="onSelectTaxType"
          :outlined="outlinedInputs"
        ></taxes-list-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea label="Notes" v-model="notes" :outlined="outlinedInputs" />
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
import TaxesListSelect from "../../shared/TaxesListSelect.vue";
export default {
  name: "invoice-adjustment-dialog",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { BasicDialog, TaxesListSelect },

  data() {
    return {
      debug: false,
      amount: this.value.amount ? this.value.amount : 0,
      notes: this.value.notes ? this.value.notes : "",
      vatCode: "",
      vatPercent: 0,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return Number(this.amount) != 0 && this.vatCode != "";
    },
  },

  methods: {
    onSelectTaxType(payload) {
      //console.log("tax selected", payload);
      this.vatCode = payload.code;
      this.vatPercent = payload.percentage;
    },
    onSave() {
      this.$emit("save", {
        amount: Number(this.amount),
        vatCode: this.vatCode,
        vatPercent: this.vatPercent,
        notes: this.notes,
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/finances/purchase-invoices/InvoiceAdjustmentDialog.vue